import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import global from './jp/global';
import memberCenter from './jp/memberCenter';
import product from './jp/product';
export default _objectSpread(_objectSpread(_objectSpread({
  message: '-'
}, global), memberCenter), product);